import _ from 'lodash';

const djangoAuth = function($q, $http, localStorageService, $rootScope, $timeout) {
    // AngularJS will instantiate a singleton by calling "new" on this function
    var service = {
        /* START CUSTOMIZATION HERE */
        // Change this to point to your Django REST Auth API
        // e.g. /api/rest-auth  (DO NOT INCLUDE ENDING SLASH)
        API_URL: '',
        // Set use_session to true to use Django sessions to store security token.
        // Set use_session to false to store the security token locally and transmit it as a custom header.
        use_session: true,
        /* END OF CUSTOMIZATION */
        authenticated: null,
        authPromise: null,
        request: function(args) {
            // Let's retrieve the token from the cookie, if available
            if (localStorageService.get('token')) {
                $http.defaults.headers.common.Authorization = 'Token ' + localStorageService.get('token');
            }
            // Continue
            params = args.params || {};
            args = args || {};
            var deferred = $q.defer(),
                url = this.API_URL + args.url,
                method = args.method || 'GET',
                params = params,
                data = args.data || {};
            // Fire the request, as configured.

            // let canceler = $q.defer();

            $http({
                url: url,
                withCredentials: this.use_session,
                method: method.toUpperCase(),
                // headers: {'X-CSRFToken': $cookies['csrftoken']},
                params: params,
                data: data
                // timeout: canceler.promise
            }).then(
                response => {
                    deferred.resolve(response.data, response.status);
                },
                response => {
                    let { status, headers, config } = response;

                    console.log('error syncing with: ' + url);

                    const data = {};
                    data.status = status;

                    if (status == 502) {
                        data['details'] = ['Could not connect. Please try again.'];
                    } else if (status == -1) {
                        data['details'] = ['Server timed out. Please try again.'];
                    } else {
                        data['details'] = response.data['details'] || response.data['non_field_errors'];
                    }

                    deferred.reject(data);
                }
            );

            // $timeout(() => {
            //     canceler.resolve();
            // }, 2000);

            return deferred.promise;
        },
        register: function(username, password1, password2, email, more) {
            var data = {
                username: username,
                password1: password1,
                password2: password2,
                email: email
            };
            data = angular.extend(data, more);
            return this.request({
                method: 'POST',
                url: '/registration/',
                data: data
            });
        },
        login: function(username, password) {
            var djangoAuth = this;
            console.debug('Login executed!');
            delete $http.defaults.headers.common.Authorization;
            localStorageService.remove('token');
            return this.request({
                method: 'POST',
                url: '/login/',
                data: {
                    username: username,
                    password: password
                }
            }).then(function(data) {
                if (!djangoAuth.use_session) {
                    $http.defaults.headers.common.Authorization = 'Token ' + data.key;
                    localStorageService.set('token', data.key);
                }
                djangoAuth.authenticated = true;
                $rootScope.$broadcast('djangoAuth.logged_in', data);
            });
        },
        logout: function() {
            var djangoAuth = this;
            return this.request({
                method: 'POST',
                url: '/logout/'
            }).then(function(data) {
                delete $http.defaults.headers.common.Authorization;
                localStorageService.remove('token');
                djangoAuth.authenticated = false;
                $rootScope.$broadcast('djangoAuth.logged_out');
            });
        },
        changePassword: function(password1, password2) {
            return this.request({
                method: 'POST',
                url: '/password/change/',
                data: {
                    new_password1: password1,
                    new_password2: password2
                }
            });
        },
        resetPassword: function(email) {
            return this.request({
                method: 'POST',
                url: '/password/reset/',
                data: {
                    email: email
                }
            });
        },
        profile: function() {
            return this.request({
                method: 'GET',
                url: '/user/'
            });
        },
        updateProfile: function(data) {
            return this.request({
                method: 'PATCH',
                url: '/user/',
                data: data
            });
        },
        verify: function(key) {
            return this.request({
                method: 'POST',
                url: '/registration/verify-email/',
                data: { key: key }
            });
        },
        confirmReset: function(uid, token, password1, password2) {
            return this.request({
                method: 'POST',
                url: '/password/reset/confirm/',
                data: {
                    uid: uid,
                    token: token,
                    new_password1: password1,
                    new_password2: password2
                }
            });
        },
        authenticationStatus: function(restrict, force) {
            // Set restrict to true to reject the promise if not logged in
            // Set to false or omit to resolve when status is known
            // Set force to true to ignore stored value and query API
            restrict = restrict || false;
            force = force || false;
            if (this.authPromise == null || force) {
                this.authPromise = this.request({
                    method: 'GET',
                    url: '/user/'
                });
            }
            var da = this;
            var getAuthStatus = $q.defer();
            if (this.authenticated != null && !force) {
                // We have a stored value which means we can pass it back right away.
                if (this.authenticated == false && restrict) {
                    getAuthStatus.reject('User is not logged in.');
                } else {
                    getAuthStatus.resolve();
                }
            } else {
                // There isn't a stored value, or we're forcing a request back to
                // the API to get the authentication status.
                this.authPromise.then(
                    function() {
                        da.authenticated = true;
                        getAuthStatus.resolve();
                    },
                    function() {
                        da.authenticated = false;
                        if (restrict) {
                            getAuthStatus.reject('User is not logged in.');
                        } else {
                            getAuthStatus.resolve();
                        }
                    }
                );
            }
            return getAuthStatus.promise;
        },
        initialize: function(url, sessions) {
            this.API_URL = url;
            this.use_session = sessions;
            return this.authenticationStatus();
        }
    };
    return service;
};

djangoAuth.$inject = ['$q', '$http', 'localStorageService', '$rootScope', '$timeout'];

export { djangoAuth };



// WEBPACK FOOTER //
// ./app/components/auth/auth.service.js